import React from 'react';
import CommentsSection from './common/CommentsSection';

interface PostMarginaliaProps {
  postId: string;
  postAuthorId?: string;
}

const PostMarginalia: React.FC<PostMarginaliaProps> = ({ postId, postAuthorId }) => {
  return (
    <div>
      <div className="mb-5">
        <h2 className="font-serif text-2xl text-[color:var(--wf-ink)]">Marginalia</h2>
        <p className="mt-2 text-sm leading-7 text-[color:var(--wf-ink-soft)]">
          Notes from fellow travelers, questions, and the occasional useful disagreement.
        </p>
      </div>
      <div className="rounded-[0.85rem] border border-[color:var(--wf-border)] bg-[rgba(255,255,255,0.24)] px-5 py-6 sm:px-6">
        <CommentsSection postId={postId} postAuthorId={postAuthorId} />
      </div>
    </div>
  );
};

export default PostMarginalia;
